import {
  APIError,
  customFetch,
  ErrorMessage,
  FetchParams,
  DEFAULT_API_URL,
} from '../../common';

type RequestHeaders = {
  callerId: string;
};

export const getUrl = async ({
  fetchFn,
  params,
}: {
  fetchFn: typeof fetch;
  params: UrlGenesisV2.PathUserNavigationurlgenesisv2PostRequest &
    RequestHeaders &
    FetchParams;
}): Promise<UrlGenesisV2.PathUserNavigationurlgenesisv2PostResponse> => {
  const {
    callerId,
    fetchParams: { timeout, baseUrl = DEFAULT_API_URL } = {},
    ...body
  } = params;
  const path = 'user_navigation/urlgenesis/v2';
  const url = `${baseUrl}/${path}`;
  const requestOptions = {
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      'nike-api-caller-id': callerId,
    },
    method: 'POST',
    path,
    timeout,
    vipAddress: 'user_navigation-urlgenesis-v2',
  };

  const result = await customFetch({
    fetchFn,
    options: requestOptions,
    url,
  });

  try {
    return await result.json();
  } catch (e) {
    throw new APIError(ErrorMessage.JSON_PARSE, {
      originalMessage: e.message,
      requestBody: JSON.parse(requestOptions.body),
      requestOptions,
      url,
    });
  }
};
